<template>
    <div class="control">
        <multiselect
            @input="setApproverForUser()"
            v-model="selectedApprover" 
            :options="usersFormatted"
            :placeholder="$t('input.choose')"
            track-by="key"
            label="name"
            :select-label="$t('input.choose')"
            :deselect-label="$t('input.remove')">
        </multiselect>
    </div>
</template>

<script>
import firebase from '@/firebase'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
    name: 'InputApproverFor',
    components: {
      Multiselect,
    },
    props: {
        uid: String,
    },
    data() {
        return {
            selectedApprover: null,
            approverWhenMounted: null,
        }
    },
    firebase: function() { 
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        const userid = JSON.parse(localStorage.getItem('profile')).user_id;
        return {
            approvers: {
                source: firebase.database().ref('/organisations/' + tenantid + '/users/' + this.uid + '/adminCanEdit/approvers'),
                asObject: true,
                readyCallback() {
                    if(this.approvers) {
                        this.selectedApprover = this.approvers;
                    }
                }
            },
            allUsers: {
                source: firebase.database().ref('/organisations/' + tenantid + '/users/'),
                readyCallback() {
                }
            }
        }
    },
    mounted() {
        // used when removing old approver
        this.approverWhenMounted = this.selectedApprover
    },
    computed: {
        usersFormatted() {
            return _.map(this.allUsers, function(user) {
                return {
                    key: user['.key'],
                    name: user.userCanEdit.name
                }
            })
        }
    },
    methods: {
        setApproverForUser() {
            if(this.approverWhenMounted.key && this.uid) {
                this.$firebaseRefs.allUsers.child(this.approverWhenMounted.key + '/adminCanEdit/approverFor/' + this.uid).set(false)
            }
            if(this.selectedApprover && this.uid) {
                this.selectedApprover.timestamp = moment().format()
                this.$firebaseRefs.approvers.set(this.selectedApprover)
                this.$firebaseRefs.allUsers.child(this.selectedApprover.key + '/adminCanEdit/approverFor/' + this.uid).set(true)
                this.approverWhenMounted = this.selectedApprover
            }
        }
    }
}
</script>

<style>

</style>
